<template>
    <div class="device-ct">
        <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
        <nav class="nav">
            <header class="module-title">
                <h1>医学兽医模型</h1>
            </header>

            <div class="ct-content">
                <article class="single-col-card">
                    <!-- 1. 标题 + 主轮播 -->
                    <h2 class="title_T">{{ titleT[0] }}</h2>
                    <figure class="main-banner carImg">
                        <el-carousel>
                            <el-carousel-item v-for="item in imgUrl[0]" :key="item">
                                <img loading="lazy" class="carousel_img banner-img" :src="item"
                                    alt="犬类、大小鼠兽医幻影模型整体实拍图" />
                                <div class="banner-glow"></div>
                            </el-carousel-item>
                        </el-carousel>
                    </figure>

                    <!-- 2. 三段描述文字 -->
                    <section class="text-wrap">
                        <p class="text-content">{{ p[0] }}</p>
                        <p class="text-content">{{ p[1] }}</p>
                        <p class="text-content">{{ p[2] }}</p>
                    </section>

                    <!-- 3. 产品部件 -->
                    <h2 class="title_T">{{ titleT[1] }}</h2>
                    <div style="display: flex;flex-wrap: wrap;justify-content: space-between">
                        <el-image lazy class="proParts main-banner" :preview-src-list="imgUrl[1]"
                            v-for="item in imgUrl[1]" :key="item" :src="item" alt="兽医动物幻影模型拆分部件展示" />
                    </div>

                    <!-- 4. 产品图片轮播 -->
                    <h2 class="title_T">{{ titleT[2] }}</h2>
                    <figure class="main-banner proImg">
                        <el-carousel>
                            <el-carousel-item style="display: flex;justify-content: space-between"
                                v-for="(item, index) in imgUrl.slice(2, 5)" :key="index">
                                <img loading="lazy" class="forImg banner-img" v-for="iem in item" :key="iem" :src="iem"
                                    alt="犬类大小鼠医学仿真模体产品实拍照片" />
                            </el-carousel-item>
                            <div class="banner-glow"></div>
                        </el-carousel>
                    </figure>

                    <!-- 5. 产品特性标签（ul列表，利于SEO抓取） -->
                    <h2 class="title_T">{{ titleT[3] }}</h2>
                    <ul
                        style="display: flex;flex-wrap: wrap;padding: 0 3px;gap: 2%;justify-content: space-between;margin:0;padding-inline-start:0;">
                        <li class="tagWidth" :style="{ marginBottom: tags.length - 1 == index ? '0' : '16px' }"
                            v-for="(tag, index) in tags" :key="tag">
                            <el-tag effect="dark">
                                <i class="el-icon-success"></i>
                                {{ tag }}
                            </el-tag>
                        </li>
                    </ul>

                </article>
            </div>
        </nav>
    </div>
</template>

<script>
import PullDown from "@/components/home/pullDown.vue";

export default {
    props: {
        hidePullDown: {
            type: Boolean,
            default: false // 默认显示
        }
    },
    name: "VeterinaryPhantomModel",
    components: {
        PullDown
    },
    data() {
        return {
            wWidth: window.innerWidth,
            titleT: [
                '犬类/鼠幻影模型',
                '——产品部件——',
                '——产品图片——',
                '——产品特性——',
                '——适用场景（X线,CT,MRI）——'
            ],
            tags: [
                'AI高精度解剖复刻技术',
                '犬类模型具备可活动仿真关节',
                '完整心肺血管与内脏解剖系统',
                '兼容大小鼠/犬类多规格幻影模型',
                '支持尺寸、内部结构按需定制',
                '适配X射线、CT、MRI多模态影像',
                '仿真MRI组织弛豫参数，成像逼真',
                '坚固耐用，可反复实训与设备校准',
                '多国兽医机构联合研发',
                '面向兽医教学与小动物科研场景'
            ],
            p: [
                '系列动物解剖幻影模型包含犬类幻影模型与Rat Phantom大小鼠幻影模型，由多国顶尖兽医机构联合研发，依托真实动物CT数据集，结合先进AI算法高精度复刻解剖结构。犬类模型原型为两岁37公斤雄性斗牛獒与罗得西亚脊背混种犬，完整还原骨骼与软组织；大小鼠幻影基于大鼠/小鼠平均解剖结构构建，所有模型均可根据成像需求定制外形尺寸、内部结构与成像性能，适配兽医临床实训、小动物生物医学研究、影像设备测试校准等场景。',
                '全系列模型支持X光、CT、MRI多模态成像应用。模型组织搭载仿真弛豫参数，拥有逼真的T2弛豫时间，适配各类T2加权MRI成像以及质子密度成像；同时支持T1加权成像，T1仿真值约100毫秒，满足多样化影像序列研究与教学实训需求。',
                '犬类幻影配备高灵活度活动关节，运动姿态贴近真实犬只，精细优化肝、脾、胰腺血管、完整心脏结构与整套肠道系统，结构坚固可长期反复使用；大小鼠幻影支持灵活定制改造，可匹配不同实验方案与成像设备，广泛应用于兽医院校培训、小动物影像预实验、医学成像设备校准工作。'
            ],
            imgUrl: [
                [
                    require('@/assets/phantom/animals10.png'),
                    require('@/assets/phantom/animals9.png'),
                    require('@/assets/phantom/animals5.1.png'),
                    require('@/assets/phantom/animals6.1.png'),
                ],
                [
                    require('@/assets/phantom/animals8.png'),
                    require('@/assets/phantom/animals9.png'),
                    require('@/assets/phantom/animals11.png'),
                    require('@/assets/phantom/animals5.png'),
                    require('@/assets/phantom/animals6.png'),
                    require('@/assets/phantom/animals3.jpg'),

                ],
                [
                    require('@/assets/phantom/animals8.png'),
                    require('@/assets/phantom/animals9.png'),
                    require('@/assets/phantom/animals10.png'),
                ],
                [
                    require('@/assets/phantom/animals11.png'),
                    require('@/assets/phantom/animals12.png'),
                    require('@/assets/phantom/animals13.png'),
                ],
                [
                    require('@/assets/phantom/animals5.png'),
                    require('@/assets/phantom/animals6.png'),
                    require('@/assets/phantom/animals2.jpg'),
                ],
            ],
        }
    },
    mounted() {
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        handleResize() {
            this.wWidth = window.innerWidth;
        }
    },
    created() {
    }
}
</script>

<style lang="scss" scoped>
.device-ct {
    width: 100%;
    padding: 1rem;
    margin-top: 80px;
    background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
    box-sizing: border-box;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

    @media (max-width: 767px) {
        margin-top: 60px;
        padding: 0.5rem;
    }

    .nav {
        width: 60%;
        margin: 0 auto;
        border: none;
        border-radius: 20px;
        background: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(10px);
        box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
            0 8px 24px rgba(37, 75, 156, 0.06);
        transition: all 0.3s ease;
        overflow: hidden;
        margin-top: 20px;

        @media (max-width: 1024px) {
            width: 80%;
        }

        @media (max-width: 767px) {
            width: 100%;
            border-radius: 16px;
            box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
        }

        &:hover {
            box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
        }
    }

    .module-title {
        padding: 2.5rem 2rem 1.5rem;
        font-size: 1.75rem;
        font-weight: 700;
        color: #1a365d;
        text-align: center;
        letter-spacing: 0.04em;
        position: relative;
        background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        flex-wrap: wrap;

        h1 {
            margin: 0;
            font-size: inherit;
            font-weight: inherit;
        }

        @media (max-width: 767px) {
            font-size: 1.25rem;
            padding: 1.5rem 1rem 1rem;
            gap: 8px;
        }

        &::after {
            content: "";
            width: 100px;
            height: 4px;
            background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
            border-radius: 4px;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .ct-content {
        padding: 2.5rem 3rem 3rem;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        gap: 48px;

        @media (max-width: 1024px) {
            padding: 2rem 2rem 2.5rem;
            gap: 36px;
        }

        @media (max-width: 767px) {
            padding: 1.5rem 1rem 1.5rem;
            gap: 28px;
        }
    }

    .single-col-card {
        background: #fff;
        display: flex;
        flex-direction: column;
        gap: 32px;
        width: 100%;
        margin: auto;
    }

    // 全局统一文字样式
    .text-content {
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        font-size: 0.95rem;
        line-height: 2;
        color: #1e293b;
        text-align: justify;
        letter-spacing: 0.01em;
        position: relative;
        padding-left: 1rem;
        border-left: 3px solid transparent;

        @media (max-width: 767px) {
            font-size: 0.85rem;
            line-height: 1.85;
            padding-left: 0.75rem;
        }

        &:first-of-type {
            margin-bottom: 2rem;
            border-left-color: #3b82f6;
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
            padding: 0.75rem 1rem 0.75rem 1.5rem;
            border-radius: 0 8px 8px 0;

            @media (max-width: 767px) {
                padding: 0.5rem 0.75rem 0.5rem 1rem;
            }
        }

        &:last-of-type {
            margin-bottom: 2rem;
            border-left-color: #3b82f6;
            background: linear-gradient(90deg, rgba(139, 92, 246, 0.04) 0%, transparent 100%);
            padding: 0.75rem 1rem 0.75rem 1.5rem;
            border-radius: 0 8px 8px 0;

            @media (max-width: 767px) {
                padding: 0.5rem 0.75rem 0.5rem 1rem;
            }
        }
    }

    .title_T {
        font-size: 1.1rem;
        line-height: 2.2;
        color: #2563AF;
        margin: 0;
    }

    // 轮播大图统一样式
    .carImg.main-banner,
    .proImg.main-banner {
        position: relative;
        border-radius: 14px;
        overflow: hidden;
        box-shadow: 0 8px 30px rgba(26, 75, 140, 0.12);
        width: 100%;
    }

    .banner-glow {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 45%;
        background: linear-gradient(to top, rgba(26, 75, 140, 0.22), transparent);
        pointer-events: none;
        z-index: 1;
    }

    .banner-img {
        width: 100%;
        height: 100%;
        display: block;
        transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
        object-fit: cover;
        object-position: center 55%;

    }

    .main-banner:hover .banner-img {
        transform: scale(1.035);
    }

    :deep(.el-carousel__container) {
        height: 437px;
    }

    // 部件小图
    .proParts.main-banner {
        position: relative;
        border-radius: 14px;
        overflow: hidden;
        box-shadow: 0 8px 30px rgba(26, 75, 140, 0.12);
        width: 18%;
        transition: all 0.3s ease;
        margin-bottom: 20px;

        img {
            width: 100%;
            height: auto;
            transition: transform 0.4s ease;
        }

        &:hover img {
            transform: scale(1.04);
        }
    }

    .forImg {
        width: 32%;
        border-radius: 8px;
        overflow: hidden;
        transition: transform 0.4s ease;

        &:hover {
            transform: scale(1.04);
        }
    }

    .forImg+.forImg {
        margin-left: 20px;
    }

    // 标签区域
    .tagWidth {
        width: 48%;
        list-style: none;
    }

    :deep .el-tag {
        text-align: left;
        width: 40vh;
    }

    :deep .el-tag--dark {
        background-color: #0969B2;
        border-color: #0969B2;
    }

    .el-tag+.el-tag {
        margin-left: 20px;
    }

    // 轮播箭头穿透样式
    :deep .el-carousel__arrow {
        background-color: rgba(44, 139, 218, 0.53);
    }

    .proImg :deep .el-carousel__container {
        height: 37vh;
    }

    // 移动端适配
    @media only screen and (max-width: 767px) {
        .tagWidth {
            width: 100%;
        }

        .carImg :deep .el-carousel__container {
            height: 17vh;
        }

        .proImg :deep .el-carousel__container {
            height: 19vh;
        }

        .proParts {
            width: 47.5%;
        }

        .proParts:not(:last-child) {
            margin-bottom: 20px;
        }

        :deep .el-tag {
            width: 100%;
        }
    }
}

// 暗色模式适配
@media (prefers-color-scheme: dark) {
    .device-ct {
        background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

        .nav {
            background: rgba(20, 30, 50, 0.92);
            backdrop-filter: blur(12px);
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

            .module-title {
                color: #93bbfc;
                background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);

                &::after {
                    background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
                }
            }

            .ct-content {
                background: #0f1a2e;

                .single-col-card {
                    background: #142033;
                }

                .text-content {
                    color: #c8d6e8;

                    &:first-of-type {
                        background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
                    }

                    &:last-of-type {
                        background: linear-gradient(90deg, rgba(139, 92, 246, 0.08) 0%, transparent 100%);
                    }
                }

                .title_T {
                    color: #60a5fa;
                }
            }
        }
    }
}

// 全局导航统一穿透样式
:deep .global-nav[data-v-5e75b752] {
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
    color: #0f3059;
    background: transparent;
}
</style>